import { defineMessages } from 'react-intl';

const helpMessages = defineMessages({
  pageTitle: {
    id: 'help.pageTitle',
    defaultMessage: 'Help',
    description: 'The page title of the help page, appears in the browser tab.',
  },
  headerTitle: {
    id: 'help.headerTitle',
    defaultMessage: 'What can we help you with?',
    description: 'Main header of the help page.',
  },
  sectionTroubleshooting: {
    id: 'help.sectionTroubleshooting',
    defaultMessage: 'Troubleshooting',
    description: 'Troubleshooting section header of the help page.',
  },
  sectionFAQ: {
    id: 'help.sectionFAQ',
    defaultMessage: 'FAQ',
    description: 'FAQ section header of the help page.',
  },
});

export default helpMessages;
